import BaseApi from '@/api/Base/BaseApi'
import {
  CreateModelRetrainNodePayload,
  GetModelRetrainNodeDetailResponse,
  GetReferenceNodesPipelineInfoResponse,
  UpdateModelRetrainNodePayload,
  ModelRetrainExportPayload
} from '@/api/ModelRetrainNode/types'

const ROOT = '/model-retrain'

const defaultPaginationOptions = {
  itemsPerPage: 40,
  page: 0,
  sortDir: 'asc',
  sortKey: 'datasetItemId',
}

// FIXME: type
export default class ModelRetrainNodeApi extends BaseApi {
  createModelRetrainNode(payload: CreateModelRetrainNodePayload) {
    const { projectId, ...rest } = payload
    return this.agent.post(`/project/${projectId}/modelRetrain/create`, rest)
  }

  updateModelRetrainNode(payload: UpdateModelRetrainNodePayload) {
    const { modelRetrainNodeId, name, ...rest } = payload
    return this.agent.put(`${ROOT}/${modelRetrainNodeId}`, { ...rest, name: name?.trim() })
  }

  exportModelRetrain(payload: ModelRetrainExportPayload) {
    const { modelRetrainNodeId, ...rest } = payload
    return this.agent.post(`${ROOT}/${modelRetrainNodeId}/export`, rest)
  }

  getModelRetrainNodeDetail(modelRetrainNodeId: string) {
    return this.agent.get<GetModelRetrainNodeDetailResponse>(`${ROOT}/${modelRetrainNodeId}`)
  }

  getReferenceNodesPipelineInfo(modelRetrainNodeId: string) {
    return this.agent.get<GetReferenceNodesPipelineInfoResponse>(`${ROOT}/${modelRetrainNodeId}/pipeline`)
  }

  // downloadModelRetrain(payload: any) {
  //   const { aiJobId, ...rest } = payload
  //   return this.agent.post(`${ROOT}/${aiJobId}/download`, rest)
  // }
}
